<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox">
      <div class="fullbox_cont text-center">
        <div class="anime_Connent">
          <span class="icon-computer"></span>
          <div class="status_dongleImgBox">
            <img class="img-responsive" src="@/assets/images/error_page/dongle_direction.svg" alt="">
          </div>
          <span class="icon-bike_connect"></span>
        </div>

        <p v-if="getMgOpen"
           class="red"> {{ $t('connectFailed.failedMsg.mg') }}
        </p>

        <!-- <div v-if="isDGUpdate" :class="style"> -->
        <div v-else-if="isDGUpdate" class="box_dongleUpdateBox">
          <p>{{ $t('connectBike.dongleLatestVersion')}}<br /> {{ $t('connectBike.pleaseWait')}}</p>
          <div class="state_run" :class="updateDGInfo.style">
            <div class="progress">
              <div class="progress-bar"
                  role="progressbar"
                  aria-valuenow="2"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{'width': updateDGInfo.progressbar + '%'}">
              </div>
            </div>
            <span> {{ updateDGInfo.progressbar }}% </span>
          </div>
          <p> {{ updateDGInfo.message }} </p>
          <div v-if="isDGupdateFailed" class="text-center mt20">
            <button class="btn btn_normalBtn"
                    type="button"
                    @click="funcReconnect">{{ $t('connectFailed.btnReconnect') }}</button>
          </div>
          <p v-else class="red hasIcon">{{ $t('connectBike.doNotDisconnectUSB') }}</p>
        </div>

        <div v-else>
          <p>{{ $t('connectBike.pleaseConnectYourBike') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import { bikeWbConnectAPI } from '@/mixins/websocket-api';
import { connectJsBikeApi } from '@/mixins/connect-bike-api';
import * as connectBikeAPI from '@/api/connect-bike';
import { mapGetters } from 'vuex';

export default {
  name: 'ConnectBike',
  mixins: [bikeWbConnectAPI, connectJsBikeApi],
  data () {
    return {
      isDGUpdate: false,
      isDGupdateFailed: false,
      driverPartNo: '',
      dongleNewVer: '',
      updateDGInfo: {
        progressbar: 0,
        message: '',
        style: ''
      },
      fwData: {
        'G': {
          'FWData': '',
          'FWChecksum': ''
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      getMGopen: 'bikeConnect/getMGopen',
      getDGFWVer: 'bikeConnect/getDGFWVer',
      getDGpartNumber: 'bikeConnect/getDGPartNumber'
    }),
    errorState () {
      return {
        MgOpen: this.getMGopen
      };
    },
    getMgOpen () {
      return this.$store.state.bikeConnect.mgOpen;
    }

  },
  methods: {
    funcReconnect () {
      location.reload();
    },
    getDgPartNumforQuery (partNumber) {
      return partNumber === 'HD030' ? 'HD-040' : partNumber;
    },
    async funcGetBikeLatestFWApi (partNumber) {
      const partNoList = [this.getDgPartNumforQuery(partNumber)];
      let message = { PartNoList: partNoList };
      const encryptData = funcEncryptData(message);
      const data = await connectBikeAPI.getBikeLatestFW(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      if (data.ErrorCode > 0) {
        return;
      }
      this.dongleNewVer = data.FwList[0].LatestFW;
      return this.dongleNewVer;
    },
    async funcGetPartFWDataAPI (partType, partNo) {
      let message = { PartNo: partNo };
      const encryptData = funcEncryptData(message);
      const data = await connectBikeAPI.getPartFWData(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      if (data.ErrorCode > 0) {
        return;
      }
      this.fwData[partType] = data;
    },
    async funcForceDGUpgrade (partNumber) {
      await this.funcGetPartFWDataAPI('G', this.getDgPartNumforQuery(partNumber));
      this.ws.UpgradeDongle(this.fwData['G']['FWData'], this.fwData['G']['FWChecksum']);
    },
    funcChangeUpgradeStatus (status, message, progress) {
      // (零件型態, 更新狀態,  提示訊息,更新進度)
      this.updateDGInfo.progressbar = progress;
      if (message.length > 0) {
        this.updateDGInfo.message = message;
      }
      this.updateDGInfo.style = {
        'state_success': status === 'S',
        'state_process': status === 'P',
        'state_failed': status === 'F'
      };
    },
    async funcCheckDGUpdate () {
      const dgCurrectVer = this.getDGFWVer;
      const dgPartNumber = this.getDGpartNumber;
      console.log('Current dongle ver:%s - %s', dgCurrectVer, dgPartNumber);
      const dgNewestVer = await this.funcGetBikeLatestFWApi(dgPartNumber);
      console.log('Latested dongle ver:%s', dgNewestVer);
      if (dgCurrectVer < dgNewestVer || dgCurrectVer === 'FF') {
        this.isDGUpdate = true;
        // 更新dg
        this.funcForceDGUpgrade(dgPartNumber);
      } else {
        this.ws.CheckPower();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fullbox_cont {
  @include pc-width {
    width: 1200px;
  }
}

.anime_Connent {
  .status_dongleImgBox {
    flex-basis: 150px;
    align-self: center;
  }
}

p {
  color: lighten($grey, 5%);
  @include rem(font-size, 2.8rem);
  margin-top: 66px;
  margin-bottom: 0;
}

.bike_connectList {
  font-size: 0;
  margin-top: 20px;
  li {
    display: inline-block;
    @include rem(font-size, 2.4rem);
    &:not(:last-child) {
      &:after {
        content: "\f105";
        display: inline-block;
        @extend %icons-f;
        margin: 0 15px;
      }
    }
  }
}

.box_dongleUpdateBox {
  margin-top: 66px;
  .state_run {
    @include gridbox(grid, auto 50px,10px,0);
    margin-left: auto;
    margin-right: auto;
    width: 580px;
    .progress {
      align-self: center;
    }
    +p {
      @include rem(font-size, 1.8rem);
    }
  }
  .hasIcon {
    margin-bottom: 0;
    &:before {
      content: "\e928";
      display: inline-block;
      @include rem(font-size, 2.4rem);
      @extend %icons-m;
      margin-right: 10px;
    }
  }
  p {
    color: $black;
    @include rem(font-size, 2.2rem);
    margin: 0 0 30px;
  }
}
</style>
